@if (isAWS) {
  <div class="flex flex-col">
    <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-100 fs-16">
      <mat-icon svgIcon="report_problem" class="icon-md-2 h-50 w-50 not-supported"></mat-icon>
      <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_SUPPORTED_FOR_AWS' | transloco}}</div>
    </div>
  </div>
} @else if (jumpboxLoading && (!featuresMap[FeatureKeys.JUMPBOX_PII] || !featuresMap[FeatureKeys.JUMPBOX_LIVE])) {
  <div class="flex flex-col">
    <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-30 fs-16">
      <img src="/assets/images/feature_not_available.png"> 
      <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_AVAILABLE' | transloco}}</div>
    </div>
  </div>
} @else if (!permissionsMap[PermissionKeys.JUMPBOX_READ_PII] || !permissionsMap[PermissionKeys.JUMPBOX_READ_LIVE]) {
  <!-- displaying no data message if don't have permission -->
  <div class="flex flex-col">
    <div class="flex flex-col empty-panel ml-72 mr-72 mt-32 justify-center" >
      <div class="empty-data flex flex-col items-center ">
        <img class="w-106" alt="don't have permission" src="/assets/images/jumpbox_no_permission.png">
        <div class="flex mt-6 ">{{'JUMPBOX.NO_PERMISSION' | transloco }}</div>
      </div>
    </div>
  </div>
} @else {
<div *ngIf="jumpboxData?.length > 0 && !apiNotFound" class="ml-72 mr-72 mt-24 mb-24 jumpbox-container">
  <div class="flex flex-row items-center justify-between header-section">
    <div *ngIf="!jumpboxLoading && showJumboxMenu" class="flex items-center">
      <div class="mat-subtitle-2 mb-0 fs-24 fw-600 pl-20 pt-20">{{'JUMPBOX.JUMPBOX' | transloco}} <span *ngIf="!jumpboxLoading">
        ({{searchTerm?.length > 0 && searchedResult ? searchedResult.length : jumpboxes?.length}})
      </span></div>
      <app-search-filter *ngIf="jumpboxes?.length > 0 || isFilterResultEmpty" class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
      <div *ngIf="jumpboxes?.length > 0 || isFilterResultEmpty" class="vertical-dash ml-12 mr-12 mt-20"></div>
      <div *ngIf="jumpboxes?.length > 0 || isFilterResultEmpty" class="mt-20" >
        <button class="flex justify-center items-center jumpbox-filter pl-6 pr-16 h-34" (click)="filterColumns()">
          <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
          <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
        </button>
      </div>
    </div>
    <div class="flex items-center">
      <mat-icon *ngIf="(!jumpboxLoading && jumpboxes?.length > 0) || isFilterResultEmpty" class="mr-16 mt-16 cursor-pointer" (click)="refreshClick()" svgIcon="refresh"></mat-icon>
      <button *ngIf="(((permissionsMap[PermissionKeys.JUMPBOX_CREATE_LIVE]) || ( permissionsMap[PermissionKeys.JUMPBOX_CREATE_PII])) && (featuresMap[FeatureKeys.JUMPBOX_PII] || featuresMap[FeatureKeys.JUMPBOX_LIVE]) && !jumpboxLoading && jumpboxes?.length > 0)  || isFilterResultEmpty && (featuresMap[FeatureKeys.JUMPBOX_PII] || featuresMap[FeatureKeys.JUMPBOX_LIVE])" type="submit" class="flex accent h-32 mt-16 mr-20" (click)="onCreateNewJumpbox()"><mat-icon svgIcon="add" class="mr-6 mt-6 icon-sm"></mat-icon>{{'BUTTONS.CREATE' | transloco}}</button>
    </div>
  </div>
  <div class="flex flex-row items-center pl-20">
    @if (selectedStatus?.length > 0) {
      <span class="pr-8 fs-16 mt-20">{{ 'TOOLBAR.STATUS' | transloco }}</span>
    }
    <div class="mt-20 mr-4 pt-8 pb-8 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedStatus?.length > 0">
      <span *ngFor="let status of selectedStatus" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
        {{getStatusLabel(status)}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelStatusFilter(status)"></mat-icon>
      </span>
    </div>
    @if (selectedDatazone?.length > 0) {
      <span class="pr-8 fs-16 mt-20">{{ 'TOOLBAR.DATEZONE' | transloco }}</span>
    }
    <div class="mt-20 mr-4 pt-8 pb-8 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedDatazone?.length > 0">
      <span *ngFor="let datazone of selectedDatazone" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
      {{datazone | titlecase}}
      <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelDatazoneFilter(datazone)"></mat-icon>
      </span>
    </div>
    @if (filterStartDate && filterEndDate) {
      <span class="pr-8 fs-16 mt-20">{{ 'JUMPBOX.DATE_CREATED' | transloco }}:</span>
    }
    <div class="mt-20 mr-4 pt-8 pb-8 filtered-items flex items-center fs-16 fw-500" *ngIf="filterStartDate && filterEndDate">
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
        {{ datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
        <span class="ml-8">
          <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelCreatedDateFilter()"></mat-icon>
        </span>
      </span>
    </div>
    <div class="mt-20 mr-4 pt-8 pb-8 filtered-items flex items-center fs-16 fw-500" *ngIf="filterModifiedStartDate && filterModifiedEndDate">
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
        <span class="date-label">{{'JUMPBOX.DATE_MODIFIED' | transloco}}:</span>
        {{ datePipe.transform(filterModifiedStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterModifiedEndDate, 'dd MMM yyyy') }}
        <span class="ml-8">
          <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelModifiedDateFilter()"></mat-icon>
        </span>
      </span>
    </div>
    <div class="flex flex-row items-center mt-20">
      <span *ngIf="selectedDatazone?.length > 0 || selectedStatus?.length > 0  || (filterModifiedStartDate && filterModifiedEndDate) || (filterStartDate && filterEndDate)" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"
        (click)="resetJumpboxFilter()">
        {{ 'BUTTONS.CLEAR_ALL' | transloco }}
      </span>
    </div>
  </div>
  <div class="p-20 pt-24">
    <div *ngIf="jumpboxLoading" class="flex spinner-container spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </div>
    <app-table [ngClass]="{'disabled': showLoader}" (jumpboxTable)="getJumpboxes()" [initialDataSource]="jumpboxes" [searchTerm]="searchTerm" [displayColumns]="displayColumns" [dataLoading]="jumpboxLoading" [showSkeletonLoader]="false"  [dataSourceLength]="showJumboxMenu" page="jumpbox" [initialCreate]="jumpboxData?.length === 0" (searchedResults)="searchedItems($event)"></app-table>

  </div>
</div>
<!-- displaying empty page when jumpbox not created -->
<div *ngIf="((permissionsMap[PermissionKeys.JUMPBOX_CREATE_LIVE]) || ( permissionsMap[PermissionKeys.JUMPBOX_CREATE_PII])) && !apiNotFound && !jumpboxResponse" class="flex flex-col ml-60" >
  <h2 class="mat-headline-5 mt-20 ml-10 mb-0">{{'JUMPBOX.JUMPBOX' | transloco}}</h2>
  <div class="flex flex-col empty-panel ml-10 mr-72 mt-16">
    <div class="empty-data flex flex-col items-center mt-32 ">
      <img class="w-106" alt="jumpbox not found" src="/assets/images/service_not_found.png">
      <div class="flex mt-6 ">{{'JUMPBOX.NO_JUMPBOX' | transloco }}</div>
    </div>
    <div class="flex justify-center mt-24">
      <button *ngIf="featuresMap[FeatureKeys.JUMPBOX_PII] || featuresMap[FeatureKeys.JUMPBOX_LIVE]" type="button" class="flex accent justify-center items-center mat-subtitle-2" mat-button
        (click)="onCreateNewJumpbox()">
        <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
        {{'JUMPBOX.CREATE_JUMPBOX' | transloco }}
      </button>
    </div>
  </div>
</div>
<div *ngIf="apiNotFound" class="ml-72 mr-72 mt-24 mb-24 jumpbox-container flex flex-col justify-center empty-wrapper">
  <div class="empty-data flex flex-col items-center text-center">
        <img src="assets/images/api_service_unavailable.png" alt="No jumpboxe API" class="empty-img" />
        <p class="empty-msg fs-16 fw-500 whitespace-pre-line">{{'JUMPBOX.JUMPBOX_API_UNAVAILABLE' | transloco}}</p>
  </div>
</div>
<div *ngIf="showLoader">
  <mat-card class="flex spinner-container load-spinner">
    <mat-spinner diameter="24"
      color="primary"
      mode="indeterminate">
    </mat-spinner>
  </mat-card>
</div>
}